export default "__VITE_ASSET__G1rVGgf2__"